import swal from 'sweetalert'
export default {
  name: 'list',
  components: {},
  props: [],
  data () {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        'index',
        // A column that needs custom formatting
        { key: 'name', label: 'Full Name' },
        // A regular column
        'age',
        // A regular column
        'sex',
        // A virtual column made up from two fields
        { key: 'nameage', label: 'First name and age' }
      ],
      items: [
        { name: { first: 'John', last: 'Doe' }, sex: 'Male', age: 42 },
        { name: { first: 'Jane', last: 'Doe' }, sex: 'Female', age: 36 },
        { name: { first: 'Rubin', last: 'Kincade' }, sex: 'Male', age: 73 },
        { name: { first: 'Shirley', last: 'Partridge' }, sex: 'Female', age: 62 }
      ]
    }
  },
  computed: {
    list_status () {
      return this.$store.getters['ChecklistItemStatus/getListStatus']
    }
  },
  mounted () {
  
    Promise.all([
      this.$store.dispatch('ChecklistItemStatus/getListStatus')
    ]).then(res => {
      
    }).catch(errors => {
      
    })
  },
  methods: {
    addChkItemstt(){
      this.$router.push('create')
    },
    edit (status) {
      this.$router.push('edit/' + status.id)
    },
    destroy (status) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
          
            this.$store.dispatch('ChecklistItemStatus/destroyStatus', {
              status
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
            }).catch(errors => { })
            
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist-item-status/list/list.js